if (document.getElementById('vue-contact')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: [ '[[', ']]' ],
		mixins: [ baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin, MobileValidate ],
		el: '#vue-contact',
		data: {
			formFields: {
				first_name: {
					label: gettext('prénom'),
					component: 'input',
					model: {}
				},
				last_name: {
					label: gettext('nom'),
					component: 'input',
					model: {}
				},
				company: {
					condition: () => window.site_id === 2,
					label: gettext('société'),
					component: 'input',
					model: {}
				},
				position: {
					condition: () => window.site_id === 2,
					label: gettext('fonction'),
					component: 'input',
					model: {}
				},
				email: {
					label: gettext('email'),
					component: 'input',
					model: {},
					validate: 'email'
				},
				phone_number: {
					label: gettext('téléphone'),
					component: 'input',
					model: {}
				},
				subject_instit: {
					condition: () => window.site_id === 2,
					label: gettext('objet'),
					component: 'input',
					model: {}
				},
				subject: {
					condition: () => window.site_id === 1,
					label: gettext('ma demande concerne'),
					component: 'select',
					default: 'Résidétape',
					options: [],
					model: {}
				},
				message: {
					label: gettext('votre message'),
					component: 'textarea',
					model: {}
				}
			},
			formDisabled: false
		},
		created() {
			this.$validator.localize('fr');
			this.$validator.extend('phone', MobileValidate);
			this.getResidences();
		},
		mounted() {},
		methods: {
			sendForm() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						let data = {};
						data.site_id = window.site_id;
						Object.keys(this.formFields).forEach((key) => {
							if (this.formFields[key].component === 'select') {
								data[key] = this.formFields[key].model.label;
							} else {
								data[key] = this.formFields[key].model.value;
							}
						});
						this.post('contact-form', data)
							.then((response) => {
								this.formDisabled = true;
							})
							.catch((error) => {
								// console.log(error);
							});
					}
				});
			},
			getResidences() {
				this.get('dropdowns/residence-list', {}, false).then((response) => {
					this.formFields.subject.options = this.formFields.subject.options.concat(
						response.data.map((el) => (response.data[el] = { label: el.label, value: el.value }))
					);
				});
			}
		}
	});
}
